export default __webpack_public_path__ + "images/2a823122-file_download_black_24dp.svg";